import { useAtomValue } from 'jotai';
import { isEqual } from 'lodash-es';
import { useRef } from 'react';
import { useFormContext } from 'react-hook-form';
import { CustomKpiTemplateFormValues } from '../../../../../schemas/kpi-template.schema';
import { kpiConfigByIdMapAtom } from '../../../../../services/state/KPIConfigState';

export function useCustomKpiTemplateDirty(): boolean {
  const { watch, formState } = useFormContext<CustomKpiTemplateFormValues>();
  const kpiConfigMap = useAtomValue(kpiConfigByIdMapAtom);

  // Re-snapshot the kpi config map whenever react-hook-form's defaultValues changes,
  // so a successful save (reset(formData)) clears configsDirty alongside formState.isDirty.
  const initialMapRef = useRef(kpiConfigMap);
  const prevDefaultValuesRef = useRef(formState.defaultValues);
  if (prevDefaultValuesRef.current !== formState.defaultValues) {
    prevDefaultValuesRef.current = formState.defaultValues;
    initialMapRef.current = kpiConfigMap;
  }

  // Compare by content, not reference — useKpiConfigActions refetches the full kpi list
  // via getAllKPIs() after any KPI write, so every entry gets a new reference even
  // when its content didn't change.
  const referencedIds = watch('sections').flatMap((s) => s.kpis);
  const configsDirty = referencedIds.some(
    (id) => !isEqual(initialMapRef.current.get(id), kpiConfigMap.get(id))
  );
  return formState.isDirty || configsDirty;
}
